import { useContext } from "react";
import { MerchantProfileContext } from "./MerchantProfileProvider";

export default function useMerchantProfileContext() {
  return useContext(MerchantProfileContext);
};
